import request from '@/utils/request'

export function count() {
  return request({
    url: 'admin-auth/api/visits',
    method: 'post'
  })
}

export function get() {
  return request({
    url: 'admin-auth/api/visits',
    method: 'get'
  })
}

export function getChartData() {
  return request({
    url: 'admin-auth/api/visits/chartData',
    method: 'get'
  })
}
